import React from 'react';

const Services = () => {
    return (
        <div>
            <h1>Our Services</h1>
            <p>Details about services offered.</p>
        </div>
    );
};

export default Services;